'use strict';

module.exports = {
  FOOD: 'food',
  GLASS: 'glass',
  PAPER: 'paper'
};


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-interesting/ItemTypes.js
 ** module id = 40
 ** module chunks = 0
 **/